import {css} from "@emotion/css";
import React, {useState} from "react";
import {GenderDeterminationSelection} from "./UserInformation";
import {
    calculateMembershipDuration,
    convertUniversalDateTimeToPersianDateTime,
    convertUniversalDateToPersianDate
} from "../../util/DateConvertor";
import {UserService} from "../../serverService/userService/UserService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect} from "react";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDatePicker, RaikoFlexAlignEnd,
    RaikoFlexAlignStart,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoGridThreeColumn, RaikoGridTwoColumn, RaikoLabel, RaikoLabelType,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSquareImagePreview,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

import style from "./UserBasicInformation.module.scss"
import {RaikoIconTypes} from "../../raikoComponents/raikoIcon/RaikoIconTypes";
import {RaikoIcon} from "../../raikoComponents/raikoIcon/RaikoIcon";
import {LocationService} from "../../serverService/provinceService/LocationService";
import UserBanAccess from "./UserBanAccess";

export default function UserBasicInformation({userId, setFullName,updatePageTitle}) {

    const service = new UserService();
    const locationService = new LocationService()

    const loading = new LoadingHelper(useLoadingDispatcher());

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [gender, setGender] = useState("");
    const [signupAt, setSignupAt] = useState("");

    const [avatarUrl, setAvatarUrl] = useState("")
    const [displayName, setDisplayName] = useState("")

    const [selectedCity, setSelectedCity] = useState(-1)
    const [selectedProvince, setSelectedProvince] = useState(-1)

    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])

    const [memberShipDuration, setMemberShipDuration] = useState("")

    console.log("selectedCity", selectedCity)

    useEffect(() => {
        getUserInformationFromServer()
        getProvincesFromServer()
    }, [userId]);

    function getUserInformationFromServer() {
        loading.show()
        service.getUserInformation(userId).then(
            response => {
                setFirstName(response.firstName)
                setLastName(response.lastName)
                setPhoneNumber(response.phoneNumber.toString().replace("989", "09"))
                setNationalCode(response.nationalCode)
                setGender(response.gender)
                setSignupAt(convertUniversalDateTimeToPersianDateTime(response.signupAt))
                setMemberShipDuration(calculateMembershipDuration(response.signupAt).text)

                setAvatarUrl(response.avatar.downloadUrl)
                setDisplayName(response.displayName)

                if (response.firstName && response.lastName)
                    setFullName(`${response.firstName} ${response.lastName}`)
                else
                    setFullName(response.phoneNumber)


                setSelectedProvince(response.selectedCityResponse ? response.selectedCityResponse.provinceId : -1)
                setSelectedCity(response.selectedCityResponse ? response.selectedCityResponse.id : -1)


            }
        ).catch(reason => {
            console.log("error is ", reason)
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateUserInformation() {
        if (checkAllFields()) {
            loading.show()
            service.updateUserInformation(userId, firstName, lastName, displayName, nationalCode, gender,selectedCity).then(
                response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                    updatePageTitle(`${firstName} ${lastName}`)
                }
            ).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkAllFields() {
        let state = false
        let message = ""
        if (!firstName || firstName.trim().length === 0) {
            message = "لطفا  نام را وارد نمایید."
        } else if (!lastName || lastName.trim().length === 0) {
            message = "لطفا نام خانوادگی را وارد نمایید."
        } else if (parseInt(nationalCode) === 0) {
            message = "لطفا کد ملی را وارد نمایید."
        } else if (!gender || gender.length === 0) {
            message = "لطفا جنسیت را وارد نمایید."
        } else
            state = true
        if (message.length > 0)
            showWarningMessage(message)
        return state
    }

    function getProvincesFromServer() {
        setProvinces([raikoCustomSelectItemGenerator(-1, "در حال دریافت استان ها ...")])
        locationService.getProvinces()
            .then(response => {
                setProvinces([])
                response.map((item) => {
                    setProvinces(prev => [
                        ...prev,
                        raikoCustomSelectItemGenerator(item.id, item.name)
                    ])
                })

                /*if (selectedProvince === -1)
                    setSelectedProvince(response[0].id)*/

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
            setProvinces([raikoCustomSelectItemGenerator(-1, "خطا در دریافت استان ها...")])
        })
    }


    useEffect(() => {
        if (typeof selectedProvince !== 'undefined' && selectedProvince >= 0) {
            getCities()
        }
    }, [selectedProvince]);


    function getCities(cityId = selectedProvince) {
        setCities([raikoCustomSelectItemGenerator(-1, "در حال دریافت شهر ها ...")])
        locationService.getCity(cityId)
            .then(response => {
                setCities([])
                response.map((item) => {
                    setCities(prev => [
                        ...prev,
                        raikoCustomSelectItemGenerator(item.id, item.name)
                    ])
                })

                /*if (selectedCity === -1)
                    setSelectedCity(response[0].id)*/
            }).catch(reason => {

            showErrorMessage(detectServerErrorMessage(reason))
            setCities([raikoCustomSelectItemGenerator(-1, "خطا در دریافت شهر ها...")])

        })
    }


    /*function handleSelectCity() {
        setCityName(`${findSelectedProvinceName()},${findSelectedCityName()}`)
        setSelectedProvinceId(selectedProvince)
        setCityId(selectedCity)
        handleCloseDialog()
    }*/

    function findSelectedProvinceName() {
        let _province = ""

        provinces.map((item) => {
            if (item.id === selectedProvince)
                _province = item.name
        })

        return _province
    }

    function findSelectedCityName() {
        let _city

        cities.map((item) => {
            if (parseInt(item.id) === parseInt(selectedCity)) {
                _city = item.name
            }
        })

        return _city;

    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                <div className={style.baseInfoContainer}>
                    <RaikoBaseCardContainer
                        className={style.avatarContainer}
                    >

                        <img className={style.avatarImage} src={avatarUrl} alt=""/>
                        <RaikoGridOneColumn className={style.avatarInfoContainer}>
                            <RaikoFlexFirstChildGrowOne
                                className={css`
                                    gap: 2rem;
                                    justify-content: center;
                                    align-items: center;
                                    flex-wrap: nowrap;
                                `}>
                                <RaikoGridOneColumn className={css`gap: .25rem;`}>
                                    <RaikoLabel
                                        text={displayName && displayName.length > 0 ? displayName : "کاربر بی نام"}
                                        raikoLabelType={RaikoLabelType.TITLE}/>
                                    <RaikoLabel text={phoneNumber} raikoLabelType={RaikoLabelType.SUBTITLE}/>
                                </RaikoGridOneColumn>
                                <RaikoIcon
                                    icon={"ic-verified"}
                                    onClick={_ => {

                                    }}/>
                            </RaikoFlexFirstChildGrowOne>
                            <RaikoFlexFirstChildGrowOne
                                className={css`
                                    flex-wrap: nowrap;
                                `}
                            >
                                <RaikoLabel text={`سن عضویت ${memberShipDuration}`} raikoLabelType={RaikoLabelType.SUBTITLE}/>
                            </RaikoFlexFirstChildGrowOne>
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                    <RaikoGridOneColumn
                        className={css`flex-grow: 1;`}
                    >

                        <RaikoBaseCardContainer

                            className={css`flex-grow: 1;`}
                        >
                            <RaikoSectionContainer
                                title={"اطلاعات پایه"}
                                hasActionButton
                                actionButtonOnclick={handleUpdateUserInformation}
                            >


                                <RaikoGridThreeColumn>
                                    <RaikoSimpleInputOutlined
                                        labelText={"نام"}
                                        setValue={setFirstName}
                                        value={firstName}/>

                                    <RaikoSimpleInputOutlined
                                        labelText={"نام خانوادگی"}
                                        setValue={setLastName}
                                        value={lastName}/>

                                    <RaikoSimpleInputOutlined
                                        labelText={"نام کاربری"}
                                        setValue={setDisplayName}
                                        value={displayName}/>

                                    <RaikoNumberInputOutlined
                                        maxLength={"10"}
                                        value={nationalCode}
                                        setValue={setNationalCode}
                                        labelText={"کد ملی"}
                                    />

                                    <RaikoCustomSelect
                                        labelText={"جنسیت"}
                                        setValue={setGender}
                                        items={[
                                            raikoCustomSelectItemGenerator(GenderDeterminationSelection.MALE.key, GenderDeterminationSelection.MALE.name),
                                            raikoCustomSelectItemGenerator(GenderDeterminationSelection.FEMALE.key, GenderDeterminationSelection.FEMALE.name),
                                        ]}
                                        value={gender}
                                    />

                                    <RaikoCustomSelect
                                        labelText={"استان"}
                                        items={provinces}
                                        value={selectedProvince}
                                        setValue={id => {
                                            setSelectedProvince(id)
                                            getCities(id)
                                        }}

                                    />
                                    <RaikoCustomSelect
                                        labelText={"شهر"}
                                        items={cities}
                                        value={selectedCity}
                                        setValue={id => {
                                            setSelectedCity(id)
                                        }}

                                    />

                                    {/* <RaikoSimpleInputOutlined
                                    disabled={true}
                                    labelText={"تاریخ عضویت"}
                                    setValue={setSignupAt}
                                    value={signupAt}
                                />*/}
                                </RaikoGridThreeColumn>

                            </RaikoSectionContainer>
                        </RaikoBaseCardContainer>



                        <UserBanAccess userId={userId}/>

                        <RaikoBaseCardContainer>
                            <RaikoSectionContainer
                                title={"اطلاعات ساخت"}
                            >
                                <RaikoGridTwoColumn>
                                    <RaikoMobileInputOutlined
                                        labelText={"شماره همراه"}
                                        setValue={setPhoneNumber}
                                        value={phoneNumber}
                                        disabled
                                    />
                                    <RaikoSimpleInputOutlined
                                        labelText={"تاریخ ساخت"}
                                        setValue={setSignupAt}
                                        value={signupAt}
                                        disabled
                                    />
                                </RaikoGridTwoColumn>
                            </RaikoSectionContainer>
                        </RaikoBaseCardContainer>


                    </RaikoGridOneColumn>

                </div>


            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}